module.exports = __webpack_public_path__ + "static/media/bookmark-link.44e740b2.svg";